import environment from 'environment'

import { store } from 'app-redux/store'
import { handleHighlight, handleMultiSelect } from 'app-redux/active/actions/multiSelectors'

import { CardType } from 'types/deck'

// NOTE - we're importing from probability so the header has the same styles as the table
import styles from '../probability.module.scss'

export type GroupBy = 'cardName' | 'types' | 'subTypes' | 'manaValue' | 'categories' | 'keywords' | 'primary'

type Props = {
  data: string | number
  odds: number
  quantity: number
  type: GroupBy
}

const Row = ({ data, odds, quantity, type }: Props) => {
  const getCards = () => {
    const { cardMap } = store.getState().deck

    let filterFunction: (card: CardType) => boolean = () => false

    if (type === 'cardName') filterFunction = card => card.name === data
    else if (type === 'types') filterFunction = card => card.types.includes(data as string)
    else if (type === 'subTypes') filterFunction = card => card.subTypes.includes(data as string)
    else if (type === 'manaValue') filterFunction = card => Number(card.cmc) === Number(data)
    else if (type === 'categories') filterFunction = card => card.categories.includes(data as string)
    else if (type === 'keywords') filterFunction = card => card.keywords.includes(data as string)
    else if (type === 'primary') filterFunction = card => card.categories[0] === data

    return Object.values(cardMap).filter(filterFunction)
  }

  const handleClick = (e: React.MouseEvent, datum: string | number) => {
    const controlKey = environment.getOnMac() ? e.metaKey : e.ctrlKey
    const cards = getCards()

    if (controlKey) return handleMultiSelect(cards)

    handleHighlight(cards)
  }

  return (
    <button className={styles.row} onClick={e => handleClick(e, data)}>
      <span className={styles.type}>{data}</span>

      <span className={styles.count}>{quantity}</span>

      <span className={styles.odds}>{odds}%</span>
    </button>
  )
}

export default Row
